import React, { ReactElement } from 'react';
import cx from 'classnames';

import styles from './ArticlesItemAction.module.scss';

interface IArticlesItemActionProps {
  className?: string;
  onClick?: () => void;
  name: string;
  disabled?: boolean;
  inProgress?: boolean;
}

const ArticlesItemAction = (props: IArticlesItemActionProps): ReactElement => {
  const { className, onClick, name, disabled, inProgress } = props;

  return (
    <div
      className={cx(styles.container, className, { [styles.disabled]: disabled })}
      onClick={onClick}
    >
      {name}
      {inProgress && <span className="spinner" />}
    </div>
  );
};

export default ArticlesItemAction;
